import React from "react"
import PropTypes from "prop-types"
import { Grid } from "semantic-ui-react"
import CashboxCard from "./cashBoxCard"
import { contains } from "ramda"

const CashboxHolder = (props) => {
  const {
    data,
    storeId,
    deleteCashbox,
    editCashbox,
    fiscalCashbox,
    refresh,
    loadingCashboxIds,
    login,
  } = props

  const cards = data.map((card) => {
    return (
      <Grid.Column key={card.id} computer={8} tablet={16} data-test="mainGrid">
        <CashboxCard
          {...card}
          storeId={storeId}
          deleteCashbox={deleteCashbox}
          editCashbox={editCashbox}
          fiscalCashbox={fiscalCashbox}
          refresh={refresh}
          isLoading={contains(card.cashboxId, loadingCashboxIds)}
          login={login}
        />
      </Grid.Column>
    )
  })
  return <Grid>{cards}</Grid>
}

export default CashboxHolder

CashboxHolder.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      disabled: PropTypes.bool,
      name: PropTypes.string,
      storeName: PropTypes.string,
      storeAddress: PropTypes.string,
    }),
  ),
  isLoading: PropTypes.arrayOf(PropTypes.number),
  deleteCashbox: PropTypes.func,
  editCashbox: PropTypes.func,
}
